import decimalToPercent from "./decimalToPercent";
// format rate column via typeId given 
const rateFormat = (value, typeId) => {
    if (typeId == 1) {
        return decimalToPercent(value);
    }
    else {
        return value;   
    }
}

export default rateFormat; 